import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import PrimaryButton from 'features/IRWorkstation/components/Common/Buttons/PrimaryButton';
import SecondaryButton from 'features/IRWorkstation/components/Common/Buttons/SecondaryButton';

// actionButtons array structure:
// Each object maps to a button in the drawer footer. Common props are:
// - key: string (required)
// - variant: 'primary' | 'secondary' (required)
// - label: string (required)
// - onClick: function
// - href: string
// - loading: boolean
// - disabled: boolean
// Any other props are forwarded to the underlying MUI LoadingButton.
//
// Example:
// [
// 		{
// 			key: 'action-acknowledge-button',
// 			label: getButtonLabel(isAcknowledged, updatingAcknowledgement),
// 			onClick: handleClick,
// 			loading: isUpdating,
// 			variant: 'secondary',
// 		},
// 		{
// 			key: 'action-link-button',
// 			label: 'Open Link',
// 			href: 'https://example.com',
// 			variant: 'primary',
// 		},
// 	]

const BUTTON_VARIANTS = {
	primary: PrimaryButton,
	secondary: SecondaryButton,
};

const DrawerFooter = ({ actionButtons }) => (
	<Box
		sx={{
			display: 'flex',
			padding: '16px 24px',
			justifyContent: 'flex-end',
			flexWrap: 'wrap',
			flexShrink: 0,
			gap: 1,
			borderTop: '0.5px solid',
			borderColor: 'border.light',
		}}
	>
		{actionButtons.map(({ key, variant, label, ...buttonProps }) => {
			const ButtonComponent = BUTTON_VARIANTS[variant] ?? SecondaryButton;
			return (
				<ButtonComponent key={key} label={label} {...buttonProps} />
			);
		})}
	</Box>
);

DrawerFooter.propTypes = {
	actionButtons: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			variant: PropTypes.oneOf(['primary', 'secondary']).isRequired,
			label: PropTypes.string.isRequired,
			onClick: PropTypes.func,
			href: PropTypes.string,
			loading: PropTypes.bool,
			disabled: PropTypes.bool,
		})
	).isRequired,
};

export default DrawerFooter;
